import angular from 'angular'
import './publishers.service'
import './royalties.service'
import './details/details.controller'
import './users/users.controller'
import './edit/edit.controller'

angular
  .module('admin.publishers', [
    'admin.publishers.service',
    'admin.publishers.detail',
    'admin.publishers.users',
    'admin.publisher.edit',
    'admin.publishers.royalties.service',
  ])
  .controller('PublisherAdminCtrl', PublisherAdminCtrl)

/** @ngInject */
function PublisherAdminCtrl($scope, $state, $filter, $q, PublisherAdminService, UploadService) {
  var vm = this
  vm.items = []
  vm.create = false
  vm.totalUsers = 0
  vm.usersPerPage = 50
  vm.oldPage = 0
  vm.currentPage = 50
  vm.first = true
  vm.totalItems = 0
  vm.pagination = {
    current: 1,
  }

  vm.sortType = 'id'
  vm.sortReverse = false

  load(1)

  function load(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination.current = 1
    }

    if (!vm.first) {
      vm.currentPage = pageNumber * 50
      vm.oldPage = vm.currentPage - 50
    } else {
      vm.first = false
    }
    PublisherAdminService.list(vm.oldPage, 50).then(function(result) {
      if (vm.totalItems === 0) {
        vm.totalItems = result.ct
      }
      var publisher = result.results
      for (var i = 0; i < publisher.length; i++) {
        publisher[i].editing = false
        publisher[i].loadT = false
        publisher[i].loadH = false
        publisher[i]['ts-m'] = new Date(
          parseInt(
            publisher[i]['ts-m']
              .toString()
              .substring(0, publisher[i]['ts-m'].toString().length - 3),
          ),
        )
        publisher[i].ry = ''
        if (publisher[i].roy !== undefined) {
          publisher[i].roy.map(function(item) {
            publisher[i].ry += item.t + ', '
          })
          publisher[i].ry = publisher[i].ry.slice(0, -2)
        }
      }
      vm.items = publisher
    })
  }

  vm.pageChanged = function(newPage) {
    load(newPage)
  }

  vm.add = function() {
    $state.go('admin.publishers.edit', { id: 0 })
  }

  vm.edit = function(item) {
    $state.go('admin.publishers.edit', { id: item.id })
  }

  vm.save = function(item) {
    vm.create = false
    delete item.ts
    delete item['ts-m']
    if (item.id !== undefined && item.id !== '' && item.id !== 0) {
      PublisherAdminService.update(item.id, item).then(function() {
        load(vm.pagination.current)
      })
    } else {
      PublisherAdminService.save(item).then(function() {
        load(vm.pagination.current)
      })
    }
  }

  vm.delete = function(item) {
    swal(
      {
        title: 'Delete Publisher',
        text: 'Are you sure ?',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function(isConfirm) {
        if (isConfirm) {
          PublisherAdminService.remove(item.id).then(function() {
            if (vm.items.length === 1 || vm.items.length === 25) {
              $state.reload()
            } else {
              load(vm.pagination.current)
            }
          })
        } else {
          return
        }
      },
    )
  }

  vm.sort = function(propertyName) {
    vm.sortReverse = !vm.sortReverse
    vm.sortType = propertyName
    vm.items = $filter('orderBy')(vm.items, vm.sortType, vm.sortReverse)
  }
}
